import React, { useEffect } from 'react';
import '../styles/CampaignDrawer.css';

/**
 * KnktToast — auto-dismissing toast notification
 * Props: message, subtext, type ('success'|'error'), onClose, duration (ms)
 */
export default function KnktToast({ message, subtext, type = 'success', onClose, duration = 4000 }) {
  useEffect(() => {
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [onClose, duration]);

  return (
    <div className={`knkt-toast${type === 'error' ? ' error' : ''}`}>
      <div className="knkt-toast-icon">
        {type === 'success' ? '✓' : '✕'}
      </div>
      <div className="knkt-toast-text">
        <div className="knkt-toast-title">{message}</div>
        {subtext && <div className="knkt-toast-sub">{subtext}</div>}
      </div>
      <button className="knkt-toast-close" onClick={onClose}>×</button>
    </div>
  );
}
